module.exports = __webpack_public_path__ + "img/user-9.dc0da33a.svg";